import React from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

const FormatPrice: React.VFC<{value: NumberFormatProps["value"]}> = ({
  value,
}) =>
  <NumberFormat value={value} displayType={'text'} thousandSeparator={' '}/>;

export default FormatPrice;
